
import SearchInput from "@/app/components/SearchInput";

type Status = "all" | "new" | "qualified" | "converted" | "rejected";

interface EnquiryFiltersProps {
  statuses: readonly Status[];
  activeFilter: Status;
  onFilterChange: (status: Status) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusCounts: Record<Status, number>;
}

export default function EnquiryFilters({
  statuses,
  activeFilter,
  onFilterChange,
  searchQuery,
  onSearchChange,
  statusCounts,
}: EnquiryFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 bg-white rounded-xl p-4 border border-stone-100">
      <div className="flex flex-wrap gap-2">
        {statuses.map(s => (
          <button
            key={s}
            onClick={() => onFilterChange(s)}
            className={`px-3.5 py-2 rounded-lg text-xs font-semibold transition-all ${
              activeFilter === s
                ? "text-white bg-amber-500 shadow-sm"
                : "bg-stone-50 text-stone-600 border border-stone-200 hover:bg-stone-100"
            }`}
          >
            {s.charAt(0).toUpperCase() + s.slice(1)} <span className="opacity-60">({statusCounts[s]})</span>
          </button>
        ))}
      </div>
      <SearchInput
        value={searchQuery}
        onChange={onSearchChange}
        placeholder="Search enquiries..."
        className="flex-1 sm:w-56"
      />
    </div>
  );
}
